import { render } from "./ConsumptionModeInfo.vue?vue&type=template&id=6204d46d&scoped=true"
import script from "./ConsumptionModeInfo.vue?vue&type=script&lang=js"
export * from "./ConsumptionModeInfo.vue?vue&type=script&lang=js"

import "./ConsumptionModeInfo.vue?vue&type=style&index=0&id=6204d46d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6204d46d"]])

export default __exports__